import script from "./Timeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./Timeline.vue?vue&type=script&setup=true&lang=ts"

export default script